import { PlusCircle, ThreeDotsVertical } from "react-bootstrap-icons";
import { useNavigate, useParams } from "react-router-dom";
import { Column } from "../../Components/Tables/Table";
import { header } from "../../Shared/Cards/Card.type";
import { formatDate, formatNumber, prepareSearchColumns } from "../../Utility/Utility";
import { useEffect, useState } from "react";
import CommonConfirmationModal from "../../Components/Modals/CommonConfirmationModal";
import { ApiResponse } from "../../model/common/apiResponse";
import toast from "react-hot-toast";
import { changeStatus } from "../setup/service/setup.service";
import SetupList from "../setup/list/List";
import useUserStore, { userAccess } from "../../store/auth/userStore";
import Loader from "../../Components/GlobalLoader/Loader";

export default function ComapnyAccountOverview() {
  const pageName = "Company Accounts";
  const addUrl="/account/company-account/add"
  const listUrl="/account/company-account/list-view"
  const gridUrl="/account/company-account/grid-view"
  const navigation=useNavigate();
  const { viewtype } = useParams<{ viewtype: string }>();
  const [statusData, setStatusData] = useState<any>();
  const [data, setData] = useState<any>(null);
  const [userAccess,setUserAccess] = useState<userAccess | null>(null);
  const [loading, setLoading] = useState(true);
  const [confirmModalData, setConfirmModalData] = useState({
    client_id:0,
    showconfModal: false,
    message:''
  });
  const {fetchUser}=useUserStore();
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const handleconfShow = () => {
    setConfirmModalData((prevData) => ({
      ...prevData,
      showconfModal: true
    }));
  };
useEffect(() => {
  setLoading(true);
    fetchUser().then((user:userAccess | null)=>{
      setUserAccess(user);
    }).then(()=>{
      setLoading(false);
    })
}, [fetchUser]);
  const handleconfClose = () =>{
    setConfirmModalData({
      client_id: 0,
      showconfModal: false,
      message: ``
    });
  }
  const handelEditAction = (data: any) => {
    navigation(`/account/company-account/edit/${data.id}`);
  };
  const handelDetailAction = (data: any) => {
    navigation(`/account/company-account/details/${data}`);
  };

  const onModalSubmit = (isAccept: boolean) => {
    if(confirmModalData.client_id!==0 && isAccept){
    //   deleteClient(confirmModalData.client_id).then((response:ApiResponse<any>) => {
    //     if (response.status==200) {
    //       toast.success("Client deleted successfully");
    //       setRefreshTrigger(prev => prev + 1);
    //     } else {
    //       toast.error("Failed to delete client");
    //     }
    //   });
    }
    handleconfClose();
  };
  let columns: Column[]
  if(viewtype === "list-view"){
     columns = [
        {
          name: "Account",
          selector: (row: { name: string; id:number; }) => (
            <span className="cursor-pointer text-primary" onClick={() => handelDetailAction(row?.id)}>{row?.name ? row?.name : '-'}</span>
          ),
        },
        {
          name: "No. of Warehouse(s)",
          selector: (row: { subscription_warehouses: number }) =>
          formatNumber(row?.subscription_warehouses) ?? 0,
        },
        {
          name: "No. of Client(s)",
          selector: (row: { subscription_clients: number }) =>
          formatNumber(row?.subscription_clients) ?? 0,
        },
        {
          name: "No. of User(s)",
          selector: (row: { subscription_users: number }) =>
          formatNumber(row?.subscription_users) ?? 0,
        },
        {
          name: "Date Created",
          selector: (row: { created_at: string }) => formatDate(row?.created_at),
        },
        {
          name: "Status",
          selector: (row: { is_active: boolean| number }) =>
            row.is_active === 1 ? (
              <span className="badge text-bg-light border border-2 px-3 border-info-subtle">
                Active
              </span>
            ) : (
              <span className="badge text-bg-light border border-2 px-3 border-danger-subtle">
                Inactive
              </span>
            ),
        },
        {
          name: <></>,
          selector: (row: any) => (
            <>
              <span
                className="cursor-pointer dropdown-toggle action-menu"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <ThreeDotsVertical />
              </span>
              <ul className="dropdown-menu action-items">
                {/* <li
                  className="cursor-pointer ms-3 mb-1"
                  onClick={() => handelEditAction(row)}
                >
                  Resume Setup
                </li> */}
                {
                  userAccess && userAccess?.is_spherewms_admin ? (
                    <li
                      className="cursor-pointer ms-3 mb-1"
                      onClick={() => handelEditAction(row)}
                    >
                      Edit
                    </li>
                  ):(
                    <></>
                  )
                }
                <li
                className="cursor-pointer ms-3 mb-1"
                onClick={() => handelInactiveAction(row, !row.is_active)}
              >
                  {row.is_active ? 'Inactive' : 'Active'}
              </li>
              </ul>
            </>
          ),
        },
      ];
  }else{
     columns= [
      {
        name: "Account",
        selector: (row: { name: string }) => row?.name,
      },
      {
        name: "No. of Warehouse(s)",
        selector: (row: { subscription_warehouses: number }) => row?.subscription_warehouses,
      },
      {
        name: "No. of Client(s)",
        selector: (row: { subscription_clients: number }) => row?.subscription_clients,
      },
      {
        name: "No. of User(s)",
        selector: (row: { subscription_users: number }) => row?.subscription_users,
      },
      {
        name: "Date Created",
        selector: (row: { created_at: string }) => formatDate(row?.created_at),
      },
    ];
  }

  const headers: header[] = [
    {
      name: "Company Name",
      selector: (row: { name: string; code: string }) =>
        row.name + "(" + row.code + ")",
    },
   ];
  const db_columns= [
    {
        "data": "account.id"
    },
    {
        "data": "account.code"
    },
    {
      "data": "account.name"
    },
    {
      "data": "account.subscription_warehouses"
    },
    {
      "data": "account.subscription_clients"
    },
    {
      "data": "account.subscription_users"
    },
    {
      "data": "account.created_at"
    },
    {
        "data": "account.is_active"
    }
]
  const exclude_columns:any = [];
  const search_columns = exclude_columns?prepareSearchColumns(db_columns, exclude_columns):[];
  const sorting_order=[
    {
      column: "account.id",
      dir: "desc",
    },
  ];
  const getDetails = (item: any) => {
    navigation(`/account/company-account/details/${item.id}`);
  };
  
  const handelInactiveAction = (data: any, isActive: boolean) => {
    const payload= {
    "is_active": isActive
    }
    changeStatus(`accounts/${data.id}`,payload).then((response:ApiResponse<any>) => {
          
      if(response.status==200){
        setStatusData(response.data);
        toast.success('Account status updated successfully!', {
            duration: 5000,
          });
      }else{
        toast.error('Failed to update account status!', {
            duration: 5000,
          });
      }
    

     })
  };

  const handleDataChange = (data: any) => {
    setData(data);
  };

  return !loading ? (
    <>
   <SetupList 
    pageName={pageName}
    columns={columns}
    addUrl={addUrl}
    listUrl={listUrl}
    gridUrl={gridUrl}
    viewtype={viewtype || "grid-view"}
    headers={headers}
    getDetails={getDetails}
    search_columns={search_columns}
    db_columns={db_columns}
    update_status_url={'accounts'}
    statusData={statusData}
    setStatusData={setStatusData}
    onDataChange={handleDataChange}
    data={data}
    refreshTrigger={refreshTrigger}
    handelEditAction={handelEditAction}
    listEndpoint="accounts/query"
    sorting_order={sorting_order}
    userAccess={userAccess?? null}
    />
        <CommonConfirmationModal
        customClassName="header-border"
        show={confirmModalData.showconfModal}
        confirmBtnText="YES"
        cancelBtnText="NO"
        content={<> {confirmModalData.message} </>}
        onModalSubmit={onModalSubmit}
      />
    </>
):<Loader/>
}
